<template>
    <div>
        <left-column :style="{backgroundImage:bgImg}" style="transition: all ease 0.2s"></left-column>
        <right-column>
            <h2>{{$t('step_products.heading')}}</h2>
            <p>{{$t('step_products.subheading')}}</p>
            <ul class="wgCalcProductsList"  >
                <li class="wgCalcProductsList__item" v-for="(panel,idx) of panels" :class="{selected:idx == $storage.state.summary.panels.type}" :key="'l_'+idx" @click="$storage.state.summary.panels.type = idx">{{ panel.tabLabel}}</li>
            </ul>
            <div class="wgCalcProductInfo" v-for="(panel,idx) of panels" v-show="idx == $storage.state.summary.panels.type" :key="'d_'+idx">
                <div class="wgCalcProductInfo__heading">
                    <h3 class="wgCalcProductInfo__heading-title">{{panel.title}}</h3>
                    <p>{{panel.efficiency}}</p>
                </div>
                <div class="wgCalcProductInfo__subheading">
                    <h4 class="wgCalcProductInfo__subheading-title">{{panel.subtitle}}</h4>
                    <p>{{panel.efficiencyPerSqm}}</p>
                </div>
                <div class="wgCalcProductInfo__descr" v-html="panel.description">
                </div>
            </div>
            <div class="wgCalcAddsList" v-if="this.accessoriesList.length">
                <p class="wgCalcAddsList__el wgCalcAddsList__el-label">{{$t('step_products.additions')}}:</p>
                <label class="wgCalcAddsList__el wgCalcAddsList__el-item" v-for="item of accessoriesList" :key="'acc_'+item.key" :class="{selected: $storage.state.summary.products.indexOf(item.key)!== -1}" :for="'inp_'+item.key">
                    <input type="checkbox" :value="item.key" v-model="$storage.state.summary.products" :id="'inp_'+item.key" />
                    <icon-battery /> {{ item.label }}
                </label>
            </div>
        </right-column>
    </div>
</template>
<script>
import LeftColumn from "../LeftColumn";
import RightColumn from "../RightColumn";
import IconBattery from "@/assets/battery.svg?v-component";
import steps from "./mixins/steps";
export const STEP_KEY = 'products'
const panels = window.wgCalc.products || {};
const accessoriesList = window.wgCalc.accessories || [];

export default {
    name:'StepProducts',
    mixins:[steps],
    components: {
        LeftColumn,
        RightColumn,
        IconBattery,
    },
    data(){
        return {
            panels,
            accessoriesList,
        }
    },
    beforeMount() {
        this.$storage.state.calcAllowed = true;
        if(!this.$storage.state.summary.panels.type){
            this.$storage.state.summary.panels.type = Object.keys(panels)[0];
        }

    },
    computed:{
        bgImg(){
            if(this.$storage.state.summary.panels.type){
                const accs = accessoriesList.filter( item => this.$storage.state.summary.products.indexOf(item.key)!==-1)

                if(undefined !== window.wgCalc && undefined !== window.wgCalc.products[this.$storage.state.summary.panels.type.toString()].image){

                    const imageInfo = window.wgCalc.products[this.$storage.state.summary.panels.type.toString()].image;
                    const key = this.$storage.state.summary.roof.type.toString()+'deg_'+this.$storage.state.summary.panels.type.toString()+(accs.length && window.wgCalc.showAddonImages ? '_'+accs.map(y =>{ return y.key }).join("_") : '');
                    const img =  typeof imageInfo === 'object' ?
                        undefined !== imageInfo[key] ? imageInfo[key] : ''
                        : imageInfo;
                    return  `url(${img})`;
                }

                return `url(${require('@/assets/bg/house/house_'+this.$storage.state.summary.roof.type.toString()+'deg_'+this.$storage.state.summary.panels.type.toString()+(accs.length && window.wgCalc.showAddonImages ? '_'+accs.map(y =>{ return y.key }).join("_") : '')+'.jpg')})`;
            }
            return  '';
        },
        isValid(){
            return true
        },
    },
    methods:{

        applyNext(){
            if(this.$storage.state.passed.indexOf(STEP_KEY)<=0){
                this.$storage.state.passed.push(STEP_KEY);
            }
            this.$storage.state.currentStep = this.$storage.state.steps[this.$storage.state.steps.indexOf(this.$storage.state.currentStep)+1];
        }
    }

}
</script>
<style lang="scss">
.wgCalc{
    &ProductsList{
        margin: 0;
        padding: 0 !important;
        list-style: none;
        display: flex;
        -webkit-box-align: center;
        align-items: center;
        flex-flow: row wrap;
        li{
            display: flex;
            flex-direction: row;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: justify;
            justify-content: space-between;
            cursor: pointer;
            min-width: 115px;
            max-width: 360px;
            background-color: $light;
            padding: 1.25rem;
            margin-bottom: 1rem;
            margin-right: 1rem;
            flex: 2 1 0%;
            justify-content: center;
            transition: all 0.1s ease;
            &:hover{
                background-color: darken($light, 5);
            }
            &.selected{
                background-color: var(--solar-calc-primary-color);
                color: #FFF;
            }
        }
    }
    &ProductInfo{
        border: 1px solid rgb(211, 211, 211);
        padding: 1.25rem 1.15rem;
        margin-bottom: 1rem;
        &__heading, &__subheading{
            display: flex;
            flex-direction: row;
            -webkit-box-pack: justify;
            justify-content: space-between;
            -webkit-box-align: center;
            align-items: center;
            margin-bottom: 0.5rem;

            p{
                margin-bottom: 0 !important;
                font-size: 1.1em;
            }
            &-title{
                font-size: 1em;
            }
        }
        &__heading{
            font-size: 18px;
        }
        &__subheading{
            font-size: 14px;
            font-weight: 400;
            color: rgb(150, 150, 150)
        }
    }
    &AddsList{
        display: flex;
        margin: 20px 0;
        padding: 0 ;
        input{
            display: none;
        }
        &__el{
            display: flex;
            flex-direction: row;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: start;
            justify-content: flex-start;
            font-size: 0.875rem;
            border-radius: 5px;
            padding: 0.5rem 1rem;
            &-label{
                padding-left: 0 !important;
                margin-bottom: 0 !important;

            }

            &-item{
                transition: all 0.1s ease;
                margin-right: 16px;
                cursor: pointer;
                max-width: 360px;
                background: $light;
                &:hover{
                    background-color: darken($light, 5);
                }
                &.selected{
                    background-color: $dark;
                    color: #FFF;
                }
                svg{
                    margin-right: 10px;
                }
            }
        }

    }
}
</style>
